import Footer from "./landing/footer";
import Navbar from "./landing/navbar";

const Politica = () => {
  return (
    <>
      <main className="min-h-screen bg-gradient-to-b from-background to-background/80">
        <Navbar />
        <br />
        <br />
        <br />
        <div className="p-6 space-y-6 text-sm leading-7 text-gray-900 dark:text-gray-100 max-w-3xl mx-auto">
          <h1 className="text-2xl font-bold">Políticas de Privacidad</h1>
          <p>
            En <strong>Brayan Developer</strong> (RUC 10740818401), estamos
            comprometidos con el respeto a tu privacidad y a la confidencialidad
            de la información que brindas o generas al utilizar nuestros
            servicios digitales, incluyendo el sistema de facturación
            electrónica y otros módulos empresariales.
          </p>

          <h2 className="text-xl font-semibold">Divulgación de Información</h2>
          <p>
            La información proporcionada durante una suscripción gratuita se
            utiliza exclusivamente para comunicar nuestros servicios. En una
            suscripción mensual o anual, los datos se emplean únicamente para la
            emisión de comprobantes electrónicos, su validación y envío a SUNAT.
          </p>
          <p>
            Brayan Developer no comparte información con terceros sin
            consentimiento expreso del usuario principal. La información no será
            usada con fines distintos a los descritos, salvo disposición legal.
          </p>
          <p>
            No se requiere autorización cuando la información proviene de
            fuentes públicas accesibles legalmente.
          </p>

          <h2 className="text-xl font-semibold">Seguridad de la Información</h2>
          <p>
            Contamos con medidas de seguridad adecuadas para proteger toda la
            información proporcionada y generada durante el uso de nuestra
            plataforma. Esta se almacena de forma segura en sistemas en la nube
            con acceso restringido únicamente a personal autorizado.
          </p>
          <p>
            Estas medidas buscan garantizar integridad, evitar pérdida,
            manipulación o accesos no autorizados.
          </p>

          <h2 className="text-xl font-semibold">
            Integridad de la Información
          </h2>
          <p>
            La información suministrada debe ser veraz, precisa, actualizada,
            pertinente y adecuada.
            <strong>Brayan Developer</strong> aplicará procedimientos para
            verificar su confiabilidad, en cumplimiento con la
            <strong> Ley N.º 29733 de Protección de Datos Personales</strong>.
          </p>
          <p>
            Toda información generada es responsabilidad de la empresa usuaria.
            Brayan Developer no se hace responsable de pérdidas, demandas o
            daños directos o indirectos derivados del mal uso del sistema.
          </p>

          <h2 className="text-xl font-semibold">
            Acceso a Información Personal
          </h2>
          <p>
            El representante legal o gerente de la empresa tiene derecho a
            solicitar información clara, detallada y expresa sobre sus datos.
          </p>
          <p>
            La solicitud puede hacerse vía correo a{" "}
            <a href="mailto:b@finanza.lat" className="underline">
              b@finanza.lat
            </a>{" "}
            o por otros medios autorizados. El acceso solo será otorgado con
            consentimiento del titular, salvo cuando la ley disponga lo
            contrario.
          </p>
          <p>
            En el caso de información sensible, el acceso debe ser autorizado
            por escrito, o bien por mandato legal en interés público debidamente
            justificado.
          </p>

          <h2 className="text-xl font-semibold">
            Protección y Confidencialidad de Datos Personales
          </h2>
          <p>
            Brayan Developer cumple estrictamente con lo establecido en la{" "}
            <strong>Ley N.º 29733 de Protección de Datos Personales</strong>,
            protegiendo la confidencialidad y derechos de todos los usuarios,
            clientes y/o proveedores vinculados al sistema.
          </p>

          <h2 className="text-xl font-semibold">Preguntas o Comentarios</h2>
          <p>
            Si tienes consultas o comentarios sobre esta Política de Privacidad,
            puedes escribirnos al correo
            <a href="mailto:b@finanza.lat" className="underline">
              {" "}
              b@finanza.lat
            </a>
            .
            <br />
            Lima, Perú – Brayan Developer.
          </p>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default Politica;
